import { useQuery } from '@tanstack/react-query';

import { searchResponseSchema, type ISearchResponse } from '../Interfaces/ISearch';
import { customFetcher } from './customFetcher';

export const globalSearchQueryKey = (query: string, limit: number) =>
    ['global-search', query.trim().toLowerCase(), limit] as const;

export const useGlobalSearch = (query: string, limit = 8) =>
    useQuery<ISearchResponse, Error>({
        queryKey: globalSearchQueryKey(query, limit),
        enabled: query.trim().length >= 2,
        queryFn: async () => {
            const params = new URLSearchParams({
                q: query.trim(),
                limit: String(limit),
            });
            const data = await customFetcher<unknown>({ endpoint: `/search/?${params.toString()}` });
            return searchResponseSchema.parse(data);
        },
        initialData: {
            query,
            groups: {
                events: [],
                reservations: [],
                storage: [],
                blog: [],
                accounts: [],
            },
        },
    });
